import { useEffect } from 'react'
import { Constants, Page_Padding } from '../../shared/constants'
import { Box, Button, Grid2, Typography } from '@mui/material'
import CustomDivider from '../../shared/utils/CustomDivider'
import SheInspireCard from '../../shared/components/SheInspireCard'
import AwardIconCard from '../../shared/components/AwardIconCard'
import { TextFormField } from '../../shared/components/FormFields/TextFormField'
import { useDialog } from '../../shared/hook/useDialog'
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import MainDialogBox from '../../shared/components/Dialog/DialogMainBox'
// import api from '../../assets/api/usePostApi'
import DialogFooter from '../../shared/components/Dialog/DialogFooter'
import { useToaster } from '../../shared/utils/ToasterProvider'
import { useMutation } from '@tanstack/react-query'
import { RadioFormField } from '../../shared/components/FormFields/RadioFormField'
import { useApartmentListForCourse } from '../../assets/api/useGetApi'
import { FormAutoComplete } from '../../shared/components/FormFields/FormAutoComplete'
import { usePageContentWithMeta } from '../../shared/hook/usePageContentWithMeta'
import { getImageUrl } from '../../shared/utils/getImageUrl'
import useResponsive from '../../shared/utils/Responsive'
import api from '../../assets/nodeApi/axiosInstance'

const SheInsHeading = ({ text, sx }) => {
    return <Typography sx={{
        textAlign: 'center',
        fontSize: "3rem",
        color: "#861641",
        fontFamily: "'Samarata', sans-serif",
        ...sx
    }} dangerouslySetInnerHTML={{ __html: text }} />
}


const data = [
    // {
    //     img: Constants.customImages.SheInspireFrame1,
    //     heading: "Women Empowerment Speech",
    //     text: "She is strength wrapped in grace, power laced with compassion, and courage born from resilience. "
    // },
    // {
    //     img: Constants.customImages.SheInspireFrame2,
    //     heading: "Women On A Mission",
    //     text: "She is strength wrapped in grace, power laced with compassion, and courage born from resilience."
    // },
    {
        img: Constants.customImages.SheInspireFrame3,
        heading: " She Icon Awards",
        text: "She is strength wrapped in grace, power laced with compassion, and courage born from resilience. "
    },
]

const sheInsData = [
    {
        img: Constants?.customImages?.StarIconFram1,
        heading: "Best Women of 2025",
        text: "Charlotte ( HR )",
        bgcolor: "#FBE9E9",
    },
    {
        img: Constants?.customImages?.StarIconFram2,
        heading: "Best Women of 2025",
        text: "Margaret ( HEAD )",
        bgcolor: "#FBE9F3",
    },
    {
        img: Constants?.customImages?.StarIconFram3,
        heading: "Best Women of 2025",
        text: "Nova ( CEO )",
        bgcolor: "#FBF3E9",
    },

]

const AwardData = [
    {
        img: Constants.customImages.AwardOne,
        text: "For women who ignite change",
        subText: "She Ignite Award"
    },
    {
        img: Constants.customImages.AwardTwo,
        text: "For women making a real difference",
        subText: "The Catalyst Crown Award "
    },
    {
        img: Constants.customImages.AwardThree,
        text: "For women who lead with heart ",
        subText: "Leader of light Award"
    }
]

const SheInspire = ({ onLoadingChange }) => {
    const isMediumScreen = useResponsive("md")
    const { data: Detail, isLoading } = usePageContentWithMeta("SHE_INSPIRES");


    const { open, handleClickOpen, handleClose } = useDialog();
    useEffect(() => {
        onLoadingChange(isLoading);
    }, [isLoading, onLoadingChange]);


    const { data: apartmentList, isLoading: isLoadingApartmentList } = useApartmentListForCourse();
    const ApartmentOptions = apartmentList?.data?.map((item, index) => ({
        id: index + 1,
        label: item?.apartment_name,
        value: item?.apartment_name,
    })) || [];
    const { showToaster } = useToaster();
    const initialValues = {
        name: '',
        occupation: '',
        age_range: '',
        apartment_name: '',
        phone_number: '',
        email_id: '',
        hobbies_interests: '',
        reason_for_nomination: '',
    };

    const validationSchema = Yup.object().shape({
        name: Yup.string().required('Name is required'),
        occupation: Yup.string(),
        age_range: Yup.string().required('Age range is required'),
        apartment_name: Yup.string().required('Apartment Name is required'),
        phone_number: Yup.string()
            .required('Phone Number is required')
            .matches(/^[0-9]{10}$/, 'Phone number must be 10 digits'),
        email_id: Yup.string()
            .required('Email ID is required')
            .email('Enter a valid email'),
        hobbies_interests: Yup.string(),
        reason_for_nomination: Yup.string().required('This field is required'),
    });
    const mutationUpdate = useMutation({
        mutationFn: (formData) => api.post(`she-inspires-registration`, formData,),
    });
    const handleSubmit = (values, { setSubmitting, resetForm }) => {
        mutationUpdate.mutate(values, {
            onSuccess: (response) => {
                if (response?.data?.message) {
                    showToaster('Success', response?.data?.message, 'success');
                } else {
                    showToaster('Error', "Something went wrong1", 'error');
                }
                resetForm();
            },
            onError: () => {
                showToaster('Error', "Something Went wrong while Submiting form", 'error')
            },
            onSettled: () => {
                setSubmitting(false);
            },


        });
        handleClose()
    }
    if (isLoading) return null;
    return (
        <Box px={Page_Padding}>
            {/* // segment 1 */}
            <Box
                sx={{
                    //                     position: "relative",
                    //                     // backgroundImage: `url(${Constants.customImages.SheInspreBanner})`,
                    //                     backgroundImage: `url(${isMediumScreen ?Constants.customImages.SheInspireHeroImgSm: getImageUrl(Detail?.content[0]?.data?.imageUrl)})`,
                    // width:"100%",
                    // height:"600px",


                    //                     backgroundSize: { xs: "100% 600px", sm:"100% 300px", md: "100% auto" },
                    //                     backgroundPosition: { xs: "cover", md: "top" },
                    //                     backgroundRepeat: "no-repeat",
                    //                     borderRadius: "40px",
                    //                     overflow: "hidden",

                    //                     py: { xs: "20px", md: "40px" },


                    width: "100%",
                    height: "auto",
                    aspectRatio: { xs: "16/9", sm: "16/11.5", md: "16/4" },
                    backgroundImage: `url(${isMediumScreen ? Constants.customImages.SheInspireHeroImgSm : getImageUrl(Detail?.content[0]?.data?.imageUrl)})`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "100%",
                    borderRadius: "1rem",
                    py: { xs: "20px", md: "40px" },
                    px: 1
                }}>
                <Box sx={{

                    display: "flex",
                    flexDirection: 'column',
                    alignItems: "center",

                    gap: { xs: "15px", md: "40px" }
                }}>
                    <Box>
                        <SheInsHeading text={Detail?.content[0]?.data?.heading} sx={{ fontSize: "30px" }} />

                    </Box>

                    <Typography variant='h6' color='#131B23' width={{ xs: "100%", md: "60%" }} fontWeight={200} textAlign={"center"} lineHeight={"30px"} dangerouslySetInnerHTML={{ __html: Detail?.content[0]?.data?.subheading }} />
                    {/* Empowering women in business is not just about representation; <span style={{ fontWeight: 600 }}> it's about creating opportunities for growth, leadership, and success and we do all that.</span> */}


                    <Button variant='contained' onClick={handleClickOpen} style={{ backgroundColor: "#861641" }}>{Detail?.content[0]?.data?.buttonText}</Button>
                </Box>
            </Box>


            {/* // segment 2 */}

            <Box sx={{
                backgroundImage: `url(${Constants.customImages.SheInspireImg})`,
                backgroundSize: "100% auto",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                overflow: "hidden"
            }}>
                <CustomDivider />
                <CustomDivider />
                <SheInsHeading text={Detail?.content[1]?.data?.heading} />
                <CustomDivider size={"40px"} />
                <Typography variant='body1' sx={{ color: "#1A1A1A", textAlign: "center" }} dangerouslySetInnerHTML={{ __html: Detail?.content[1]?.data?.description }} />


                <CustomDivider />
                <CustomDivider />
                <SheInsHeading text={Detail?.content[2]?.data?.heading} />
                <CustomDivider size={"40px"} />
                <Typography variant='body1' sx={{ color: "#1A1A1A", textAlign: "center" }} dangerouslySetInnerHTML={{ __html: Detail?.content[2]?.data?.description }} />

                {/* Welcome to She Inspires, a community-driven space where women can connect, share their stories, and learn from each other's successes and challenges. Our platform is dedicated to empowering women in business by providing a supportive network, valuable resources, and inspiration.
                    Whether you're just starting out or are a seasoned entrepreneur, we invite you to join our community and be part of a movement that's driving positive change and growth.
                </Typography> */}

                <CustomDivider />
                <CustomDivider />
                <SheInsHeading text={Detail?.content[3]?.data?.heading} />
                <CustomDivider size={"40px"} />
                <Typography variant='body1' sx={{ color: "#1A1A1A", textAlign: "center" }} dangerouslySetInnerHTML={{ __html: Detail?.content[3]?.data?.description }} />

                {/* A She Icon is a passionate and purpose-driven woman nominated to represent She Inspires as a brand ambassador within her community. She plays a vital role in promoting our skill development programs for children, especially within residential societies and apartment communities. These programs are designed to empower young minds with essential life skills, and our She Icons help bring them to life by spreading awareness and encouraging participation. We encourage women who resonate with our mission and are eager to drive positive change.
                </Typography> */}

                <CustomDivider />
                <CustomDivider />
                <SheInsHeading text={Detail?.content[4]?.data?.heading} />
                <CustomDivider size={"40px"} />
                <Typography variant='body1' sx={{ color: "#1A1A1A", textAlign: "center" }} dangerouslySetInnerHTML={{ __html: Detail?.content[4]?.data?.description }} />

                {/* She Icons enjoy a range of exclusive benefits—from personal branding support and public recognition to networking opportunities and leadership development. Becoming a She Icon is not just a role—it's a chance to make a lasting impact.
                </Typography> */}

                <CustomDivider />
                <CustomDivider />
                <SheInsHeading text={Detail?.content[5]?.data?.heading} />
                <CustomDivider size={"40px"} />

                <Grid2 container spacing={"2rem"} sx={{ display: "flex", placeContent: "center" }}>
                    {
                        Detail?.content[5]?.data?.events?.map((item, index) => (
                            <Grid2 children size={{ xs: 12, sm: 6, md: 4 }} key={index}>
                                <SheInspireCard item={item} />
                            </Grid2>
                        ))
                    }

                </Grid2>
            </Box>


            <CustomDivider />
            <CustomDivider />
            <SheInsHeading text={Detail?.content[6]?.data?.heading} />
            <CustomDivider size={"40px"} />
            <Typography variant='body1' sx={{ color: "#1A1A1A", textAlign: "center" }} dangerouslySetInnerHTML={{ __html: Detail?.content[6]?.data?.description }} />
            {/* The world needs more women who lead with purpose, passion, and heart. She Icons are women who inspire, uplift, and spark change. If you’re ready to shine your light and stand as a symbol of strength — this is your moment
            </Typography> */}
            <CustomDivider size={"40px"} />
            <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Button variant='contained' style={{ backgroundColor: "#861641" }}>{Detail?.content[6]?.data?.buttonText}</Button>
            </Box>

            <CustomDivider />
            {/* <CustomDivider />
            <SheInsHeading text={"Our Celebrated She Icons"} />
            <CustomDivider size={"40px"} />
            <Grid2 container spacing={"30px"}>
                {
                    sheInsData.map((item, index) => (
                        <Grid2 children size={{ xs: 12, sm: 6, md: 4 }} key={index}>
                            <StarIconCard item={item} />
                        </Grid2>
                    ))
                }

            </Grid2> */}

            <CustomDivider />
            <CustomDivider />
            <SheInsHeading text={Detail?.content[7]?.data?.heading} />
            <CustomDivider />
            <Grid2 container spacing={"2rem"}>
                {
                    Detail?.content[7]?.data?.awards?.map((item, index) => (
                        <Grid2 children size={{ xs: 12, sm: 6, md: 4 }} key={index}>
                            <AwardIconCard item={item} />
                        </Grid2>
                    ))
                }

            </Grid2>

            <MainDialogBox open={open} handleClose={handleClose} width={"60%"}>
                <Formik initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}>
                    {() => (
                        <Form>
                            <Grid2 container spacing={"30px"}>
                                <Grid2 children size={{ xs: 12, md: 6 }}>
                                    <Field
                                        name="name"
                                        component={TextFormField}
                                        label="Name"
                                        isRequired={true}

                                    />
                                </Grid2>
                                <Grid2 children size={{ xs: 12, md: 6 }}>
                                    <Field
                                        name="occupation"
                                        component={TextFormField}
                                        label="Occupation"
                                    />
                                </Grid2>
                                <Grid2 children size={{ xs: 12, md: 6 }}>



                                    <Field
                                        name="age_range"
                                        component={RadioFormField}
                                        label="Age Range"
                                        isRequired={true}
                                        options={[
                                            { label: "25–30 year", value: "25-30" },
                                            { label: "35–45 year", value: "35-45" },
                                            { label: "Other", value: "Other" },
                                        ]}
                                    />
                                </Grid2>
                                <Grid2 children size={{ xs: 12, md: 6 }}>
                                    <Field
                                        name="apartment_name"
                                        component={FormAutoComplete}
                                        options={ApartmentOptions}
                                        label="Apartment"
                                        isRequired={true}
                                        isLoading={isLoadingApartmentList}
                                    />
                                </Grid2>
                                <Grid2 children size={{ xs: 12, md: 6 }}>
                                    <Field
                                        name="phone_number"
                                        component={TextFormField}
                                        label="Phone Number"
                                        isRequired={true}
                                    />
                                </Grid2>
                                <Grid2 children size={{ xs: 12, md: 6 }}>
                                    <Field
                                        name="email_id"
                                        component={TextFormField}
                                        label="Email ID"
                                        isRequired={true}
                                    />
                                </Grid2>
                                <Grid2 children size={{ xs: 12, md: 6 }}>
                                    <Field
                                        name="hobbies_interests"
                                        component={TextFormField}
                                        label="Hobbies & Interests"
                                    />
                                </Grid2>
                                <Grid2 children size={{ xs: 12, md: 6 }}>
                                    <Field
                                        name="reason_for_nomination"
                                        component={TextFormField}
                                        label="Why do you want to nominate yourself as a She ICON"
                                        isRequired={true}
                                        multiline
                                        rows={4}
                                    />
                                </Grid2>
                                <Grid2 children size={{ xs: 6, md: 4 }}>
                                    <Button variant="outlined" fullWidth onClick={handleClose}>Cancel</Button>
                                </Grid2>
                                <Grid2 children size={{ xs: 6, md: 4 }}>
                                    <Button variant="contained" type="submit" fullWidth>Submit</Button>
                                </Grid2>
                            </Grid2>
                        </Form>
                    )}
                </Formik>
            </MainDialogBox>


        </Box>
    )
}

export default SheInspire